import React from "react";
import { Card, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { TbClubsFilled } from "react-icons/tb";
import { FaCalendarCheck } from "react-icons/fa6";
import { SiApplemusic } from "react-icons/si";
import { useAuth } from "../../src/context/AuthContext";
import { BsFillShieldLockFill } from "react-icons/bs";

const ClubDetailsComponent = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Retrieve club data from state
  const club = location.state?.club;

  // If no club data is found, show an error message
  if (!club) {
    return <h2>Club Not Found</h2>;
  }

  return (
    <Card className="club-details-card">
      <Card.Body className="d-flex">
        {/* Club Image */}
        <div className="club-logo">
          <img src={club.profilePic} alt={club.username} className="club-image" />
        </div>

        {/* Club Info */}
        <div className="club-info">
          <div className="club-header">
            <h4 className="club-name">{club.username}</h4>
            {/* <FaEllipsisH className="options-icon" /> */}
          </div>
          <p className="club-description">{club.description}</p>

          <div className="club-meta-wraper">
            {/* Club Meta Info */}
            <div className="club-meta">
              <span><FaCalendarCheck />
                {club?.date
                  ? `${new Date(club.date).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                  })}`
                  : "Date not available"}
              </span>
              <span><SiApplemusic /> {club.category}</span>
              <span><BsFillShieldLockFill /> {club.privacy}</span>
            </div>

            {/* Join Club Button */}
            
            {isAuthenticated && (
                <Button variant="outline-primary" className="join-btn">
                    <TbClubsFilled /> Join Club
                </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ClubDetailsComponent;
